import { useUI } from '@/stores/ui';
import { cn } from '@/lib/cn';

export function Toast() {
  const { toast, setToast } = useUI();
  if (!toast) return null;
  return (
    <div className="fixed bottom-6 right-6 z-50 pointer-events-none animate-slide-in-right">
      <div
        className={cn(
          'pointer-events-auto flex items-center gap-3 pl-4 pr-2 py-2 rounded-md shadow-lg text-sm font-medium text-white',
          toast.tone === 'bad' ? 'bg-bad' : toast.tone === 'ok' ? 'bg-ok' : 'bg-accent',
        )}
      >
        <span>{toast.msg}</span>
        {toast.actionLabel && toast.onAction && (
          <button
            className="px-2 py-1 rounded bg-white/15 hover:bg-white/25 text-white text-[12px] font-semibold transition"
            onClick={() => {
              toast.onAction?.();
              setToast(null);
            }}
          >
            {toast.actionLabel}
          </button>
        )}
      </div>
    </div>
  );
}
